module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "ts-loading-fade"
    },
    on: {
      "after-leave": _vm.handleAfterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "ts-loading-mask",
    class: [_vm.customClass, {
      'is-fullscreen': _vm.fullscreen
    }]
  }, [_c('div', {
    staticClass: "ts-loading-spinner"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })]), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "ts-loading-text"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2ad386e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/loading/loading.vue
// module id = 813
// module chunks = 39